import React from 'react';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import moment from 'moment';

import * as commonActions from '../../../actions/commonActions';
import SchedulesView from './SchedulesView';
import { getClassesInRangeByFilters } from '../../../utils/utils';

class SchedulesViewContainer extends React.Component {

  prepareSchedules = schedules => {
    let schedulesArray = [];
    let filteredCourses = [];
    let schedulesNoMeetings = [];
    let schedulesMeetings = [];
    let events = [[], [], [], [], [], [], []];
    const { courses } = this.props;

    if (schedules.length == 0 || courses.length == 0) return [];
    filteredCourses = schedules
      .map(schedule => commonActions.getCourseObjById(schedule.course, courses))
      .filter(item => item);
    filteredCourses.map(course => {
      if (course.meetings.length > 0) {
        schedulesMeetings.push(course);
      } else {
        schedulesNoMeetings.push(course);
      }
    });
    schedulesMeetings.map(schedule => {
      schedule.meetings.map(m => {
        const endDate = m.enddate;
        const startDate = m.startdate;
      
        if (getClassesInRangeByFilters(startDate, endDate, this.props.filteredDays)) {
          let startTime = +m.starttime.substring(0, 2) + m.starttime.substring(3, 5) / 60;
          let endTime = +m.endtime.substring(0, 2) + m.endtime.substring(3, 5) / 60;
          if (startTime < 7 || endTime > 22) {
            schedulesNoMeetings.push(schedule);
          } else {
            let startPx = (startTime - 7);
            let endPx = (endTime - 7);
            let smom = new moment(m.starttime, 'HH:mm:ss');
            let emom = new moment(m.endtime, 'HH:mm:ss');
            let eTime = emom.format('h:mm a');
            let sTime = smom.format('a') == emom.format('a') ? smom.format('h:mm') : smom.format('h:mm a');
  
            let event = {
              id: schedule.id,
              slug: schedule.slug,
              time: `${sTime}-${eTime}`,
              instructor: schedule.instructor,
              longname: schedule.longname,
              start: startPx,
              end: endPx,
              external_url: schedule.external_url
            };
            events[m.day - 1].push(event);
          }
        }
      });
    });
    schedulesNoMeetings = commonActions.unique(schedulesNoMeetings);
    let obj = {
      noMeetings: schedulesNoMeetings,
      events: events
    };
    schedulesArray.push(obj);
    return schedulesArray;
  };

  render() {
    const { assignments, assignmentsLoaded } = this.props;
    const parsedSchedules = this.prepareSchedules(assignments);
    if (!assignmentsLoaded)
      return (
        <div className="spinner-box">
          <Spinner spinnerName="three-bounce" className="mt-4" />
        </div>
      );
    if (parsedSchedules.length === 0) return <div>No schedules</div>;
    return <SchedulesView schedules={parsedSchedules} />;
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses
  };
}

export default connect(
  mapStateToProps,
  null
)(SchedulesViewContainer);



// WEBPACK FOOTER //
// ./src/components/rank/ScheduleViewAddDrop/SchedulesViewContainer.js